import {Loading} from "element-ui";

/** 该类实现了请求接口时显示加载页功能
 * showFullScreenLoading() tryHideFullScreenLoading() 会将同一时刻的请求合并。
 * 声明一个变量 needLoadingRequestCount，
 * 每次调用showFullScreenLoading方法 needLoadingRequestCount + 1。
 * 调用tryHideFullScreenLoading()方法，needLoadingRequestCount - 1。needLoadingRequestCount为 0 时，结束 loading。*/
class CustomLoading{
  constructor(){
    this.loading = null; //定义loading属性
    this.needLoadingRequestCount = 0; //同一时刻请求数
  }
  startLoading() {    //使用Element loading-start 方法
    this.loading = Loading.service({
      lock: true,
      text: '加载中...',
      background: 'rgba(0, 0, 0, 0)'
    })
  }
  endLoading() {    //使用Element loading-close 方法
    this.loading.close()
  }

  showFullScreenLoading() {
    if (this.needLoadingRequestCount === 0) {
      this.startLoading()
    }
    this.needLoadingRequestCount++
  }

  tryHideFullScreenLoading() {
    if (this.needLoadingRequestCount <= 0) return;
    this.needLoadingRequestCount--;
    if (this.needLoadingRequestCount === 0) {
      this.endLoading()
    }
  }
}

export default CustomLoading







// WEBPACK FOOTER //
// ./src/api/Http/helper.js